import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import injectIntl from 'common/injectIntl';
import queryString from 'lib/format/queryString';
import { apiDateFormatter } from 'lib/format';
import { fetchSchedule, setStatusFilter } from './actions';
import FilterGroup from './FilterGroup';

const mapDispatchToProps = (dispatch, ownProps) => ({
    onSportsFilterChange: (option) => {
        const query = ownProps.location.query || {};
        query.categoryId = option.value >= 0 ? option.value : null;
        const qs = queryString(query);
        browserHistory.replace(`/watch/schedule${qs}`);
        dispatch(fetchSchedule(query));
    },
    onReplayDateSelectorChange: (option) => {
        const startDate = new Date();
        const date = startDate.getDate();
        const endDate = new Date();
        switch (option.value) {
            case 'all':
                startDate.setDate(date - 30);
                break;
            case 'today':
                break;
            case 'last7Days':
                startDate.setDate(date - 7);
                break;
            case 'last2Weeks':
                startDate.setDate(date - 14);
                break;
            case 'last30Days':
                startDate.setDate(date - 30);
                break;
            default:
                break;
        }
        const query = ownProps.location.query || {};
        query.startDate = apiDateFormatter(startDate);
        query.endDate = apiDateFormatter(endDate);
        const qs = queryString(query);
        browserHistory.replace(`/watch/schedule${qs}`);
        dispatch(fetchSchedule(query));
    },
    onNetworkFilterChange: (option) => {
        const query = ownProps.location.query || {};
        query.channel = option.value;
        const qs = queryString(query);
        browserHistory.replace(`/watch/schedule${qs}`);
        dispatch(fetchSchedule(query));
    },
    onDateSelectorChange: (date) => {
        const query = ownProps.location.query || {};
        query.startDate = apiDateFormatter(date);
        const qs = queryString(query);
        browserHistory.replace(`/watch/schedule${qs}`);
        dispatch(fetchSchedule(query));
    },
    onStatusFilterChange: (status) => {
        dispatch(setStatusFilter(status));
        const query = ownProps.location.query || {};
        query.type = [status];
        const date = apiDateFormatter(new Date());
        let dates = [];
        if (status === 'live') {
            dates = [];
            query.startDate = null;
            query.endDate = null;
        } else if (status === 'replay') {
            const weekAgo = new Date();
            weekAgo.setDate(weekAgo.getDate() - 7);
            dates = [date, apiDateFormatter(weekAgo)];
            query.startDate = dates[0];
            query.endDate = dates[1];
        } else if (status === 'upcoming') {
            dates = [date];
            query.endDate = null;
        }
        const qs = queryString(query);
        browserHistory.replace(`/watch/schedule${qs}`);
        dispatch(fetchSchedule(query));
    }
});

const FilterGroupContainer = connect(null, mapDispatchToProps)(injectIntl(FilterGroup));

export default FilterGroupContainer;



// WEBPACK FOOTER //
// ./app/schedule/FilterGroupContainer.js